import { useState } from "react";
import SVG from "../../../Components/SVG";

export default function RememberMe() {
  const [rememberMe, setRememberMe] = useState(true);

  return (
    <label className="flex w-fit cursor-pointer items-center gap-2 select-none relative">
      <input
        type="checkbox"
        checked={rememberMe}
        onChange={(e) => setRememberMe(e.target.checked)}
        className="sr-only"
      />

      <span
        className={`flex size-3.5 items-center justify-center rounded-sm border ${
          rememberMe
            ? "border-gray-400 bg-transparent"
            : "border-gray-400 bg-transparent"
        }`}
      >
        {rememberMe && (
          <SVG name="checkMark" classname="size-2 stroke-zi-text-light dark:stroke-zi-text-dark"/>
        )}
      </span>

      <span className="text-zi-blue-light dark:text-zi-text-dark text-xs">مرا به‌خاطر بسپار</span>
    </label>
  );
}